// extracted by mini-css-extract-plugin
module.exports = {"authorDetails":"style-module__authorDetails___Ktgw2","authorPhoto":"style-module__authorPhoto___RyfOl"};